import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const matriculasApi = `${baseUrl}/matriculas`;

export const allMatriculasService = async (params) => {
  const res = await axios.get(matriculasApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveMatriculasService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${matriculasApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(matriculasApi, data, { headers: token({}) });
  }
  return res;
};

export const oneMatriculasService = async (id) => {
  const res = await axios.get(`${matriculasApi}/${id}`, { headers: token({}) });
  return res;
};

export const deleteMatriculasService = async (id) => {
  const res = await axios.delete(`${matriculasApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
